import { useCallback } from 'react';
import { sfx } from './engine.js';
import type { SfxName } from './sounds.js';

export interface UseSfxReturn {
  /** Reproduce un SFX por nombre. No-op si está muteado o gateado. */
  play: (name: SfxName) => void;
}

/**
 * Hook para disparar SFX desde componentes. Envuelve el singleton `sfx`; el
 * mute y el gating los maneja el motor, así que el componente solo llama
 * `play('correct')` sin preocuparse por el estado.
 */
export function useSfx(): UseSfxReturn {
  const play = useCallback((name: SfxName) => sfx.play(name), []);
  return { play };
}
